import {setHostAccount,AccountRevocation} from '../services/liveReviewApi';
import {getApiBaseUrl} from '../config/api';
import {fetchWithAuth} from './auth';
import {refusalText} from '../pages/live-review/account-reasons';
import {revocationText} from '../pages/live-review/AccountAction';

/** Suspend / restore for the moderation pages that are not the live console (Bulk Review, Videos).
 *  Both go through tezda-live's gated route; the rules below keep a page from saying more than the server did. */
export type SuspendOutcome={already:boolean;message:string;revocation:{text:string;warn:boolean}|null};
/** Carries on ONLY when the server says the account is already suspended (the old and the new backend both word it so).
 *  Any other 409 (blocked, inactive…) is a refusal: it is rethrown and nothing may be marked suspended. */
export async function suspendAccount(userId:string,reasonCode:string,note:string):Promise<SuspendOutcome>{
  try{
    const summary=await setHostAccount(userId,{action:'suspend',reason:note,reasonCode});
    return {already:false,message:'',revocation:revocationText((summary as {revocation?:AccountRevocation|null}).revocation)};
  }catch(e:any){
    if(e?.status===409&&/already suspended/i.test(e?.message??''))return {already:true,message:e.message,revocation:null};
    throw e;
  }
}
/** The old, moderator-gated status route (tezda-user). Returns the server's own message, if it sent one. */
export async function legacySetAccountStatus(userId:string,status:string):Promise<string>{
  const res=await fetchWithAuth(`${getApiBaseUrl()}/user/t/updateUserAccountStatus`,{method:'POST',
    headers:{'Content-Type':'application/json'},body:JSON.stringify({UserID:userId,AccountStatus:status})});
  const j:any=await res.json().catch(()=>({}));
  if(!res.ok)throw new Error(refusalText(res.status,j?.message,'Failed to update account status'));
  return typeof j?.message==='string'?j.message:'';
}
export type RestoreOutcome={via:'gated'|'legacy';message:string};
/** Restore through the gated route. A 409 means "not suspended" (blocked, inactive, already active): then, and only then, the
 *  account is set active through the old route, and what that route answered is reported. Any other error is thrown. */
export async function restoreAccount(userId:string,note:string,legacy:(id:string,status:string)=>Promise<string>=legacySetAccountStatus):Promise<RestoreOutcome>{
  try{
    await setHostAccount(userId,{action:'restore',reason:note});
    return {via:'gated',message:''};
  }catch(e:any){
    if(e?.status!==409)throw e;
    return {via:'legacy',message:await legacy(userId,'active')};
  }
}
